module.exports = __webpack_public_path__ + "img/regular.7b2c0be3.png";